module.exports = {
  draftsList: 'List of Deactivations',
  closedList: 'Closed List',
  editImage: {
    title: 'Edit Image',
  },
  header: {
    title: 'Shopping Categories',
    buttonCreate: 'Create',
    buttonPublish: 'Publish',
  },
  table: {
    title: {
      index: 'No.',
      type: 'Type',
      url: 'URL',
      action: 'Action',
      title: 'Title',
    },
    tooltip: {
      edit: 'Edit',
      delete: 'Delete',
      inactive: 'InActive',
      active: 'Active',
      schedule: 'Schedule',
    },
    popup: {
      title: 'Confirm',
      okBtn: 'Yes',
      cancelBtn: 'No',
      delete: 'Are you sure to delete this Shop Category?',
      edit: 'Are you sure to edit this Shop Category?',
      enable: 'Are you sure you want to enable this Shop Category?',
      disable: 'Are you sure you want to disable this Shop Category?',
      confirmPassword: 'Please input your password to confirm.',
    },
  },
  form: {
    image3x4: 'Please upload an image',
    imageUpload: '* Upload an image',
    assetImage: 'Asset',
    countries: 'Countries',
    btnUpdateShopCategory: 'Update',
    btnCreateShopCategory: 'Add',
    done: 'Done',
    scheduleTile: 'Schedule Shop Category',
    updateShopCategory: 'Edit Shop Category',
    createShopCategory: 'Add Shop Category',
    titleColor: 'Asset',
    btnSubmit: 'Submit',
  },
  validate: {
    countryBlank: 'Please select country!',
    imageBlank: 'Please input an image!',
    titleBlank: 'Title is required',
    ctaLinkBlank: 'URL is required',
  },
  tab: {
    detail: {
      form: {
        time: {
          title: 'Time',
          startTimePlaceholder: 'Start time',
          endTimePlaceholder: 'End time',
          startDatePlaceholder: 'Start date',
          endDatePlaceholder: 'End date',
        },
        validate: {
          titleBlank: 'Please input title.',
          countryBlank: 'Please select Country',
          descriptionBlank: 'Please input description.',
          startBeforeNow: 'The start date time must be after now.',
          endBeforeNow: 'The end date time must be after now.',
          startBeforeEnd: 'The start date must be before the end date time.',
          startTimeBlank: 'Please input start time.',
          endTimeBlank: 'Please input end time.',
          startDateBlank: 'Please input start date.',
          endDateBlank: 'Please input end date.',
          productNameBlank: 'Please input product name.',
          productDescriptionBlank: 'Please input product description.',
          productVideoTypeBlank: 'Please input product video type.',
          productVideoIdBlank: 'Please input product video id.',
          frequencyBlank: 'Please input push notifications reminder frequency.',
        },
      },
    },
  },
  message: {
    error: {
      uploadImage: 'There was an error while uploading the image. Please try again',
      requireUpload: 'Please upload an image.',
      maxItem: 'Please disable another tile before enabling a new one.',
      createShopCategory: 'Shop Category add error.',
      updateShopCategory: 'Shop Category update error.',
      insertValidUrl: 'Please insert the valid link of the Shop Category',
      uniqueTitle: 'Title must be unique',
    },
    success: {
      updateShopCategory: 'Shop Category successfully updated.',
      createShopCategory: 'Shop Category successfully added.',
      scheduleTile: 'Shop Category successfully scheduled.',
      deleteShopCategory: 'Shop Category successfully deleted.',
    },
  },
};
